import Basket from './basket.vue'

Basket.install = function (Vue) {
  Vue.component(Basket.name, Basket)
}

export default Basket
